module.exports = __webpack_public_path__ + "static/lesson_3-9776ff179edd017812defa0c90e13dca.png";